import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=7d537824"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "@/styles/main/footer.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Footer.vue?vue&type=style&index=1&id=7d537824&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports